<app-document-upload [_id]="selectedRecord.questions_id" [azureFileLocation]="azureFileLocation"
    [azureFileName]="azureFileName" [allowedFileExtentions]="allowedFileExtentions" [uploadEndpoint]="uploadEndpoint">
</app-document-upload>

<app-list-documents [_id]="selectedRecord.questions_id" [endpoint]="questionsEndpoint"></app-list-documents>